// import '../personal.css';
import '../digitalBanking.css'

import { Col, Container, Row } from "react-bootstrap";
import parse from 'html-react-parser';
import { Link } from "react-router-dom";

import { Jumbotron } from "sections";
import { LinkButton } from "components/buttons";
import wealth from "constants/wealth";
import EnquiryForm from "components/forms/EnquiryForm";
import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";

import outline_check from 'assets/images/outline_check.svg';

function ComingSoon() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron badgeText="Digital" title={`Coming <span className="jumbotron-subtitle-2">Soon<span>`} />
      </section>
      <section className="wealth">
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
             <img src="https://www.alrajhibank.com.my/assets/images/rize/coming-soon/Teaser_start.jpg" width="100%" />
            </Col>
            <Col md={10}>
              <p className="special-left">For Rize customers, <a href="https://www.alrajhibank.com.my/assets/images/rize/coming-soon/Dear_Rizer.jpg" style={{ fontWeight: "bold"}} className='no-wrap'>click here</a> to know more.</p>
              <p className="special-left">For alrajhi@24seven users, <a href="https://www.alrajhibank.com.my/assets/images/rize/coming-soon/Dear_alrajhi24seven.jpg" style={{ fontWeight: "bold"}} className='no-wrap'>click here</a> to know more.</p>
            </Col>
            <Col md={10}>
             <img src="https://www.alrajhibank.com.my/assets/images/rize/coming-soon/Teaser_end.jpg" width="100%" />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default ComingSoon;